<div class="success-modal">
  <div class="modal-title">{{'Sign-up-success.success'|translate}}</div>
  <p>
    {{'Sign-up-success.thank-you-for'|translate}}
  </p>
  <button (click)="onOkClick()" id="ok-button"> Ok </button>
</div>
